import { render, staticRenderFns } from "./chateau-belgrave.vue?vue&type=template&id=44e0fbc0&scoped=true"
import script from "./chateau-belgrave.vue?vue&type=script&lang=js"
export * from "./chateau-belgrave.vue?vue&type=script&lang=js"
import style0 from "./chateau-belgrave.vue?vue&type=style&index=0&id=44e0fbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e0fbc0",
  null
  
)

export default component.exports